var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters["session/isLogged"]
    ? _c(
        "IdleTracker",
        [
          _vm.$store.state.healthyHabits.isReadOnlyView
            ? _c(
                "b-navbar",
                {
                  staticClass:
                    "navbar-healthy-habits navbar-healthy-habits-commom navbar-login",
                  attrs: { sticky: "", toggleable: "xl" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "navbar-items-align" },
                    [
                      _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-navbar-brand",
                        {
                          staticClass: "cursor-pointer mx-auto mx-lg-0",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goPatientMenu()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "navbar-brand-img",
                            style: _vm.getLogoStyles,
                            attrs: { src: _vm.getLogo }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: { outline: "", fitContent: "" },
                      on: { click: _vm.closeTab }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  )
                ],
                1
              )
            : _c(
                "b-navbar",
                {
                  staticClass:
                    "navbar-healthy-habits navbar-healthy-habits-commom",
                  attrs: { sticky: "", toggleable: "xl" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "navbar-items-align" },
                    [
                      _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-navbar-brand",
                        {
                          staticClass: "cursor-pointer mx-auto mx-lg-0",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goPatientMenu()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "navbar-brand-img",
                            style: _vm.getLogoStyles,
                            attrs: { src: _vm.getLogo }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-navbar-toggle", {
                        attrs: { target: "nav-collapse" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "navbar-mobile-fixed navCollapse",
                      attrs: { id: "nav-collapse" }
                    },
                    [
                      _c(
                        "b-navbar-nav",
                        { staticClass: "navbar-submenu ml-auto" },
                        [
                          _c(
                            "b-nav-item",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$router.push({
                                    name: "healthyHabitsFaqs"
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [_vm._v(_vm._s(_vm.$t("doubts")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-nav-item",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showSettingModal()
                                }
                              }
                            },
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [_vm._v(_vm._s(_vm.$t("setting")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.showInSubmenu
                            ? _c(
                                "b-nav-item",
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.healthyHabits.setting
                                            .nick
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showInSubmenu
                            ? _c(
                                "b-nav-item",
                                { staticClass: "my-auto" },
                                [
                                  _c(
                                    "base-button",
                                    {
                                      staticClass: "btn-dropdown",
                                      staticStyle: {
                                        "background-color": "transparent",
                                        width: "10rem"
                                      }
                                    },
                                    [
                                      _vm.$store.state.healthyHabits.setting
                                        .nick
                                        ? _c("dropdown", {
                                            staticClass: "dropdown",
                                            attrs: {
                                              enablePortuguese: "",
                                              showLanguageSelector: "",
                                              title:
                                                _vm.$store.state.healthyHabits
                                                  .setting.nick,
                                              items: _vm.dropdownLoginItems
                                            },
                                            on: { logOff: _vm.logOff }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.showInSubmenu
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-nav-item",
                                    [
                                      _c("lang-selector", {
                                        staticClass: "d-inline-block",
                                        staticStyle: {
                                          margin: "0px !important"
                                        },
                                        attrs: { enablePortuguese: "" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-nav-item",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle.nav-collapse",
                                          modifiers: { "nav-collapse": true }
                                        }
                                      ],
                                      on: { click: _vm.logOff }
                                    },
                                    [
                                      _c(
                                        "base-button",
                                        {
                                          attrs: { outline: "", fitContent: "" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("logOff")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.$store.state.loading &&
          !_vm.$store.state.healthyHabits.hideLoadingIcon
            ? _c("loading-anim", {
                attrs: { active: _vm.$store.state.loading, fullScreen: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                noCloseOnBackdrop: "",
                noCloseOnScape: "",
                hideClose: "",
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.showMeasurableInputModal,
                title: _vm.$t("enterNewValue")
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showMeasurableInputModal = false
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("base-input", {
                    attrs: {
                      name: "new-value-input",
                      min: 0,
                      placeholder: "",
                      inlineBlock: "",
                      type: "number"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$store.state.healthyHabits.itemSelected
                                      .measureUnit
                                  ) +
                                  "\n        "
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1331934096
                    ),
                    model: {
                      value:
                        _vm.$store.state.healthyHabits.itemSelected.newValue,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$store.state.healthyHabits.itemSelected,
                          "newValue",
                          $$v
                        )
                      },
                      expression:
                        "$store.state.healthyHabits.itemSelected.newValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-1 my-1",
                      on: {
                        click: function($event) {
                          return _vm.sendMeasurableData()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: { gray: "", outline: "" },
                      on: {
                        click: function($event) {
                          _vm.$store.state.healthyHabits.itemSelected.newValue =
                            _vm.$store.state.healthyHabits.itemSelected.currentValue
                          _vm.$store.state.healthyHabits.showMeasurableInputModal = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("back")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.showGoalCompletedModal,
                title: _vm.$t("congratulations")
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showGoalCompletedModal = false
                }
              }
            },
            [
              _c("div", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("goalCompletedText")) + "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c(
                    "base-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.$store.state.healthyHabits.showGoalCompletedModal = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.form.show
              },
              on: {
                hide: function($event) {
                  return _vm.healthyHabitsFormModalHidden()
                }
              }
            },
            [
              _c("healthy-habits-form", {
                attrs: { inModal: "" },
                on: {
                  closeModal: function($event) {
                    return _vm.healthyHabitsFormModalHidden()
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.showTableLegendModal
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showTableLegendModal = false
                }
              }
            },
            [
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("healthyHabitsGeneral")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-pencil-square", { staticClass: "blue" }),
                      _vm._v(" " + _vm._s(_vm.$t("edit")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-bar-chart-fill", { staticClass: "orange" }),
                      _vm._v(" " + _vm._s(_vm.$t("stadistics")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-trash", { staticClass: "red" }),
                      _vm._v(" " + _vm._s(_vm.$t("removeOrStore")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-arrow-clockwise", { staticClass: "black" }),
                      _vm._v(" " + _vm._s(_vm.$t("restore")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-save", {
                        staticClass: "description-icon-width"
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("stored")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-trophy-fill", {
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("completed")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-progress",
                        {
                          staticStyle: {
                            display: "inline-grid",
                            "min-width": "65px"
                          },
                          attrs: { max: 100 }
                        },
                        [
                          _c("b-progress-bar", {
                            attrs: {
                              value: 50,
                              "label-html":
                                "<span style='font-weight: bold;' class='progressBarTable'>50%</span>"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("progressBar")) + "\n      ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("nonMeasurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-check-lg", {
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("completed")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-check-lg", {
                        staticClass: "partial-fill-opacity",
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("partialCompleted")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-dash", {
                        staticStyle: { color: "#3238C4" },
                        attrs: { scale: "2" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("freeDay")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-x-lg"),
                      _vm._v(" " + _vm._s(_vm.$t("uncompleted")))
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("measurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _vm._v(_vm._s(_vm.$t("measurableInfo")))
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _vm._v(_vm._s(_vm.$t("measurableInfo2")))
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "my-3", attrs: { cols: "12" } }, [
                    _c("label", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v("*" + _vm._s(_vm.$t("calendarLegendColorInfo")))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.showCalendarLegendModal
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showCalendarLegendModal = false
                }
              }
            },
            [
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("healthyHabitsGeneral")))]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("calendarInfo")))]),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("nonMeasurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("completed")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style partial-fill-opacity",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("partialCompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style linear-gradient",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("freeDay")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#979797",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("uncompleted")))]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("measurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("completed")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style partial-fill-opacity",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("partialCompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style linear-gradient",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("filled")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#979797",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("uncompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "my-3", attrs: { cols: "12" } }, [
                    _c("label", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v("*" + _vm._s(_vm.$t("calendarLegendColorInfo")))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                noCloseOnBackdrop: "",
                noCloseOnScape: "",
                hideClose: "",
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.setting.showModal,
                title: _vm.$t("setting")
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .showStoredHabits,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "showStoredHabits",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.showStoredHabits"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("showStoredHabits"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .showGoalCompletedHabits,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "showGoalCompletedHabits",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.showGoalCompletedHabits"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("showGoalCompletedHabits")
                              )
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          on: { change: _vm.allowFreeDaysChange },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .allowFreeDays,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "allowFreeDays",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.allowFreeDays"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("allowFreeDays"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .invertedCalendarDays,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "invertedCalendarDays",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.invertedCalendarDays"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("invertCalendarDays"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("base-input", {
                        staticClass: "input-form-centered",
                        attrs: {
                          tooltip: _vm.$t("notificationsEmail"),
                          placeholder: _vm.$t("notificationsEmail"),
                          type: "text"
                        },
                        model: {
                          value:
                            _vm.$store.state.healthyHabits.setting.notifications
                              .email,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$store.state.healthyHabits.setting
                                .notifications,
                              "email",
                              $$v
                            )
                          },
                          expression:
                            "$store.state.healthyHabits.setting.notifications.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("base-input", {
                        staticClass: "input-form-centered",
                        attrs: {
                          tooltip: _vm.$t("notificationsPhoneTooltip"),
                          placeholder: _vm.$t("notificationsPhone"),
                          type: "text"
                        },
                        model: {
                          value:
                            _vm.$store.state.healthyHabits.setting.notifications
                              .phone,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$store.state.healthyHabits.setting
                                .notifications,
                              "phone",
                              $$v
                            )
                          },
                          expression:
                            "$store.state.healthyHabits.setting.notifications.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function($event) {
                          return _vm.updateSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: { gray: "", outline: "" },
                      on: {
                        click: function($event) {
                          return _vm.resetSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("back")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("base-dialog", {
            attrs: {
              value: _vm.showAllowFreeDaysAdvice,
              okFn: function() {
                _vm.showAllowFreeDaysAdvice = false
              },
              cancelFn: function() {
                _vm.showAllowFreeDaysAdvice = false
                _vm.$store.state.healthyHabits.setting.allowFreeDays = true
              },
              okBtnText: _vm.$t("yes"),
              cancelBtnText: _vm.$t("no"),
              content: _vm.$t("allowFreeDaysAdvice")
            }
          }),
          _vm._v(" "),
          _c("arrow-up"),
          _vm._v(" "),
          _c("router-view", {
            staticClass: "container-md container-healthy-habits"
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d4ced80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d4ced80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/HealthyHabitsLayout.vue
// module id = 2011
// module chunks = 117